import { render, staticRenderFns } from "./teacherPortrait.vue?vue&type=template&id=50f6a72f&scoped=true"
import script from "./teacherPortrait.vue?vue&type=script&lang=js"
export * from "./teacherPortrait.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/popUp.scss?vue&type=style&index=0&id=50f6a72f&prod&lang=scss&scoped=true&external"
import style1 from "@/assets/css/table.scss?vue&type=style&index=1&id=50f6a72f&prod&lang=scss&scoped=true&external"
import style2 from "./teacherPortrait.vue?vue&type=style&index=2&id=50f6a72f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f6a72f",
  null
  
)

export default component.exports